import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { COLORS } from "@app/constants";
import { useWindowDimensions } from "@app/hooks";
import CButton from "../CButton";
// import { ThemeContext } from '@/theme/ThemeProvider'

const activeTabs = (tabs: any, item: any, size: any) => {
  return tabs === item ? size : size - 1;
};

const CTabs = ({
  tabs,
  setTabs,
  data,
  style,
  vStyle = {},
  icon,
  iconLeft,
  activeColor,
  inactiveColor,
  activeSize,
  fixedSize,
  noBorder,
  bgActiveColor,
  notActiveBgColor,
  borderActiveColor,
}: any) => {
  // const { isDarkMode } = useContext(ThemeContext)
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  const handleTabClick = (item) => {
    if (tabs !== item) {
      // alert(`Switching to tab2: ${item}`); // 디버깅용
      setTabs(item);
    }
  };

  return (
    <CTabSection style={{ ...vStyle }}>
      {data.map((item: any, index: any) => {
        return (
            <CButton
              icon={icon ? icon[index] : null}
              iconLeft={iconLeft}
              key={index.toString()}
              title={t(
                item == "L"
                  ? "limit"
                  : item == "M"
                    ? "market"
                    : item == "CL"
                      ? "climit"
                      : item == "CM"
                        ? "cmarket"
                        : item
              )}
              onClick={() => {
                handleTabClick(item);
              }}
              style={{
                pointerEvents: "auto", // 클릭 이벤트 허용
                padding: 6,
                paddingBottom: 10,
                marginBottom: -1.5,
                color:
                  tabs === item
                    ? activeColor
                      ? activeColor
                      : COLORS.primary
                    : inactiveColor || COLORS.lightGray,
                background:
                  tabs === item && bgActiveColor
                    ? bgActiveColor
                    : notActiveBgColor,
                borderBottomWidth: noBorder ? noBorder : 2,
                borderBottomColor:
                  tabs === item
                    ? borderActiveColor
                      ? borderActiveColor
                      : COLORS.primary
                    : "transparent",
                borderRadius: 0,
                fontSize: fixedSize
                  ? fixedSize
                  : width > 900
                    ? activeTabs(tabs, item, activeSize ? activeSize : 12)
                    : activeTabs(tabs, item, activeSize ? activeSize - 2 : 9),
                fontWeight: tabs === item ? "500" : "300",
                ...style,
                zIndex: 2, // 다른 요소 위로 렌더링 보장
              }}
            />

        );
      })}
    </CTabSection>
  );
};


const CTabSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px;
  padding-top: 5px;
  padding-bottom: 0;
  width: 100%;
    
    
  @media (max-width: 600px) {
    justify-content: center;
  }
`;


export default React.memo(CTabs);
